import { Roles } from '@/auth/azure/Roles'
import { createDescriptor } from '@/components/BreadCrumbs/BreadCrumbs'
import OfferEditor from '@/routes/offers/OfferEditor'
import { offerEditorRouteAction, offerEditorRouteLoader } from '@/routes/offers/OfferEditor.route'
import { RoleRouteObject } from '@/types'

const OfferCreatorRoute = {
  path: 'new',
  element: <OfferEditor creating={true} />,
  loader: offerEditorRouteLoader,
  action: offerEditorRouteAction,
  allowedRoles: [Roles.Sales, Roles.Administrator, Roles.GlobalAdministrator, Roles.Supervisor],
  handle: {
    crumb: () => createDescriptor,
  },
} as RoleRouteObject

export default OfferCreatorRoute
